import axiosInstance from '../../axios/instance'
import { normalizeToUTC } from '@revbox/helpers-fe'
import { endOfDay, startOfDay, subDays } from 'date-fns'
import { getToken } from '../../helpers/get-token'

const getSpecificAuction = async ({ search = '', page = 1 } = {}, campaignId, auctionType) => {
    try {
        const base_url = process.env.REACT_APP_HUB_URL + '/api/analytics/campaign/period/'
        const url_config = {
            content: 'content-auctions',
            branding: 'branding-ppc-auctions'
        }

        let params = new URLSearchParams()

        params.append('page', page)
        if (search) {
            params.append('search', search)
        }

        const url = base_url + url_config[auctionType] + '?' + params.toString()

        const currentPeriod = [startOfDay(subDays(new Date(), 30)), endOfDay(new Date())]

        const previousPeriod = [startOfDay(subDays(new Date(), 60)), endOfDay(subDays(new Date(), 30))]

        const token = getToken()
        axiosInstance.defaults.headers.common['authorization'] = token
        const response = await axiosInstance.post(url, {
            current_period: [normalizeToUTC(currentPeriod[0]).getTime(), normalizeToUTC(currentPeriod[1]).getTime()],
            previous_period: [normalizeToUTC(previousPeriod[0]).getTime(), normalizeToUTC(previousPeriod[1]).getTime()],
            campaign_id: Number(campaignId)
        })
        return response?.data
    } catch (error) {
        console.log(error)
    }
}

export default getSpecificAuction